import client from './client';

const holidayUrl = '/api/v1/holiday';

export const getHolidayList = (searchYear) => {
  return client.get(`${holidayUrl}/list`, {
    params: { searchYear }
  });
};

export const saveHoliday = (finalData) => {
  return client.post(`${holidayUrl}/save`, finalData);
};

export const deleteHoliday = (params) => {
  return client.post(`${holidayUrl}/delete`, params);
};
